import { __decorate } from "tslib";
import { Component } from 'decorators';
import view from './generatingInstructions.view.html';
let GeneratingInstructionsComponent = class GeneratingInstructionsComponent {
    handleCancel() {
        this.onCancel?.();
    }
};
GeneratingInstructionsComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: view,
        bindings: {
            sparkleLoadingAnimation: '<',
            currentGeneratingStatusText: '<',
            onCancel: '&?',
            bannerText: '<',
        },
    })
], GeneratingInstructionsComponent);
export { GeneratingInstructionsComponent };
